import { createContext, useContext, useMemo } from 'react';

import { type RouteConfig } from './PangeaRoutes';

type RetailLink = 'pangea';

type RetailLinkType = {
  link: RetailLink;
  allowedUrls: string[];
};

export const RetailAppLinkContext = createContext<RetailLinkType | null>(null);

const RetailAppLinkProvider: React.FC<
  React.PropsWithChildren<{
    routeConfig: RouteConfig[];
  }>
> = ({ routeConfig, children }) => {
  const allowedUrls = routeConfig.map(config => config.path);
  const value = useMemo(() => ({ link: 'pangea' as RetailLink, allowedUrls }), []);

  return <RetailAppLinkContext.Provider value={value}>{children}</RetailAppLinkContext.Provider>;
};

export const useRetailLink = () => {
  const context = useContext(RetailAppLinkContext);

  return context;
};

export default RetailAppLinkProvider;
